const updates = [
  { date: '07-31', title: '《星际迷航：新纪元》4K蓝光版全新上线', type: '上新' },
  { date: '07-30', title: '《暗夜追踪者》全集更新完毕，悬疑爱好者必看', type: '完结' },
  { date: '07-29', title: '纪录片《极地求生》4K超清画质震撼登场', type: '上新' },
  { date: '07-28', title: '《长安风云录》更新至第36集，剧情迎来高潮', type: '更新' },
  { date: '07-27', title: '韩剧《心动频率》高清双语字幕同步上线', type: '上新' },
  { date: '07-26', title: '《深海危机》全新4K重制版，画质全面升级', type: '重制' },
  { date: '07-25', title: '动漫剧场版《星辰之海》独家高清首发', type: '独家' },
  { date: '07-24', title: '《笑傲职场》第二季全12集一次性放送', type: '完结' },
  { date: '07-23', title: 'BBC纪录片《蓝色星球III》4K蓝光完整版', type: '上新' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">最新动态</h2>
          <p className="mt-3 text-sm text-foreground-500">蘑菇影视每日更新快讯，精彩内容不错过</p>
        </div>
        <div className="max-w-[720px] mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, i) => (
              <div key={i} className="relative mb-6 last:mb-0">
                <div className="absolute -left-[33px] top-1 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="bg-background-100 rounded-xl p-5 border border-background-200/70 cursor-pointer hover:border-background-300 transition-colors">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2 py-0.5 text-[11px] font-semibold rounded-md whitespace-nowrap ${
                      item.type === '上新' ? 'bg-primary-100 text-primary-700' :
                      item.type === '完结' ? 'bg-accent-100 text-accent-700' :
                      item.type === '独家' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-background-200 text-foreground-600'
                    }`}>
                      {item.type}
                    </span>
                  </div>
                  <p className="text-sm font-medium text-foreground-800">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}